const React = require('react');

const Head = ({ i18n, deviceType }) => (
  <div className="online-payments-title">
    <div className="online-payments-title__text">
      <h1>{i18n.gettext('Cobros online')}</h1>
      <p>{deviceType === 'desktop'
        ? (`${i18n.gettext('Optimiza la experiencia de pago de los clientes y ofrece pagos rápidos y seguros en todas las plataformas web y mobile')}.`)
        : ''}
      </p>
    </div>
  </div>
);

module.exports = Head;
